export const types = {
  TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
};

export const toggleSidebar = (showSidebar) => ({
  type: types.TOGGLE_SIDEBAR,
  showSidebar,
});

const INIT_STATE = {
  showSidebar: false,
};

export default function (state = INIT_STATE, action) {
  switch (action.type) {
    case types.TOGGLE_SIDEBAR:
      return {
        ...state,
        showSidebar: action.showSidebar,
      };
    default:
      return state;
  }
}

export const getShowSidebar = (state) => state.chat.sidebar.showSidebar;



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/redux/sidebar.js